import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import parse from 'html-react-parser';

//mui
import {
    Card,
    Box,
    Grid,
    Typography,
} from "@mui/material";
import { TCLabel } from 'components/TopCourtComponents/Label/TopCourtLabel';

export default function PreviewComponent({ data, orderType }) {
    const [rows, setRows] = useState([])

    useEffect(() => {
        if (data) {
            setRows(data)
        }
    }, [data])

    return (
        <>
            <Card>
                <Box sx={{ p: 3 }}>
                    <Typography variant="h4" gutterBottom>
                        Preview Terms and Conditions {orderType || ''}
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={12} lg={12}>
                            {
                                rows.length > 0 ? (
                                    rows?.map((row, index) => (
                                        <TCLabel
                                            subtitle
                                            inheritColor
                                            component="span"
                                            sx={{
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: 0.5,
                                                marginBottom: 0
                                            }}>
                                            <span>{parse(row.content)}</span>
                                        </TCLabel>
                                    ))
                                ) : (
                                    <Typography variant="body1">No terms available</Typography>
                                )
                            }
                        </Grid>
                    </Grid>
                </Box>
            </Card>
        </>
    )
}